import { FormValues } from '@models/form';

export const countryValues = {
    checkedFieldKey: 'country',
    resetFieldKey: 'state',
};

export const titleValues = {
    checkedFieldKey: 'Title__c',
    resetFieldKey: 'Title',
};

export const industryValues = {
    checkedFieldKey: 'industry',
    resetFieldKey: 'Sub_Industry__c',
};

interface ResetField {
    checkedFieldKey: string;
    resetFieldKey: string;
}

export function getResetFieldValues(
    field: string,
    value: string | boolean | string[] | number | null,
    resetFields: ResetField[] | ResetField
): FormValues {
    const updatedValues = { [field]: value };

    function resetFieldValue(resetField: ResetField): void {
        if (field === resetField.checkedFieldKey) {
            updatedValues[resetField.resetFieldKey] = '';
        }
    }

    if (Array.isArray(resetFields)) {
        resetFields.forEach((resetField) => {
            resetFieldValue(resetField);
        });
    } else {
        resetFieldValue(resetFields);
    }

    return updatedValues;
}
